import { render, staticRenderFns } from "./DatatableTree.vue?vue&type=template&id=0cf89bb8&scoped=true"
import script from "./DatatableTree.vue?vue&type=script&lang=js"
export * from "./DatatableTree.vue?vue&type=script&lang=js"
import style0 from "./DatatableTree.vue?vue&type=style&index=0&id=0cf89bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf89bb8",
  null
  
)

export default component.exports